import { isValueNullish, isValueString, ValidationError } from '@colonist/validation';
export function checkValueIsTranslationObject(value, errorMessage = 'Value is not a valid translation object') {
    if (!isValueString(value === null || value === void 0 ? void 0 : value.key)) {
        throw new ValidationError(errorMessage, value);
    }
    if (!isValueNullish(value.options)) {
        var _value_options;
        if (((_value_options = value.options) === null || _value_options === void 0 ? void 0 : _value_options.constructor) !== Object) {
            throw new ValidationError(errorMessage, value);
        }
    }
    return value;
}
